module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Jogi Információk",
	"footer.privacy.url": "http://www.grohe.hu/hu_hu/company/privacy/",
	"footer.disclaimer.text": "Impresszum",
	"footer.disclaimer.url": "http://www.grohe.hu/hu_hu/company/legal-info/",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE WaterSystems konfigurátor",
	"homepage.introtext": "Válaszoljon néhány egyszerű kérdésre és tudja meg, melyik termékünk szolgálja ki a legjobban az Ön igényeit.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Vissza a címlapra",
	"configurator.button.seeResults": "Eredmények megtekintése",
	"question1.question": "Elérhető meleg és hideg víz is a konyhájában?",
	"question1.option1.text": "Igen, mindkettő elérhető",
	"question1.option2.text": "Csak hideg víz",
	"question2.question": "Milyen jellegű vízellátással egészítené ki konyháját?",
	"question2.option1.text": "Forró vízzel, élelmiszerek és meleg italok elkészítéséhez",
	"question2.option2.text": "Hűtött, szűrt és szénsavas vízzel",
	"question2.option3.text": "Mindkettővel",
	"question3.question": "Megtartaná jelenlegi konyhai csapját?",
	"question3.option1.text": "Igen",
	"question3.option2.text": "Szeretnék új modellt választani",
	"question4.question": "Melyi legyen az elsőszámú csaptelep?",
	"question4.option1.text": "GROHE Blue Home vízszűrő",
	"question4.option2.text": "GROHE Red vízforraló",
	"question5.question": "Melyik csaptelep formát kedveli?",
	"question5.option1.text": "L-alakú kifolyó",
	"question5.option2.text": "U-alakú kifolyó",
	"question5.option3.text": "C-alakú kifolyó",
	"question6.question": "Milyen bevonatú csapot választana?",
	"question6.option1.text": "Króm",
	"question6.option2.text": "Szálcsiszolt acél",
	"question7.question": "A vízmelegítőhoz, mekkora bojler méretet választana?",
	"question7.option1.text": "M (3 Literes)",
	"question7.option2.text": "L (5.5 Literes)",
	"results.title": "{productGroupsCount, plural, \none {Javaslatunk Önnek} \nother {Javaslatunk Önnek}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "A megfelelő beszereléshez az alábbiakra is szüksége lesz:",
	"results.newConfiguration.title": "Szeretne újrakezdeni a konfigurátort?",
	"results.newConfiguration.buttonText": "Újrakezdem",
	"results.product.number": "Cikkszám: #{number}",
	"results.product.button.productInformation": "Termékinformáció",
	"results.product.button.dealerLocator": "Bemutatóterem kereső",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Termékinformáció",
	"results.product.dealer": "Bemutatóterem kereső",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.hu_hu.json
// module id = 783
// module chunks = 0